import ITheme from '../ITheme';

export default class ThemeDefault implements ITheme {
  vuetifyTheme: any =  {
    primary: '#009999',
  };
}
